  var swiper = new Swiper('.mySwiper-team', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1240: {
        slidesPerView: 3.2,
        spaceBetween: 50,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });